import gsap from 'gsap';

export default class HeaderMenu {
    static init() {
        new HeaderMenu(document.getElementById('navigation'));
    }

    constructor(element) {
        window.addEventListener('DOMContentLoaded', () => {
            let animDuration = 0.45;
            let easeVal = "expo.inOut";
            let isMobile = window.innerWidth < 768;
            let searchTrigger = document.querySelector('.search-trigger');
            let navigation = element;
            let header = document.querySelector('#header');

            let menu = {
                get element() {
                    return document.querySelector('.menu-button')
                },
                get labelElement() {
                    return this.element.querySelector('.menu-button__text')
                },
                get overlayElement() {
                    return document.querySelector('.navigation-overlay')
                },
                get labelOpen() {
                    return this.element.dataset.openLabel
                },
                get labelClose() {
                    return this.element.dataset.closeLabel
                },
                isVisible: false,
                setLabel(label) {
                    this.labelElement.innerText = label;
                },
                open() {
                    // For navigation open
                    navigation.classList.remove('navigation--is-hiding');
                    navigation.classList.remove('navigation--is-hidden');
                    setTimeout(() => {
                        header.classList.add('active');
                    }, 150)
                    NavHeaderHeight();

                    this.element.classList.add('menu-button--is-active');
                    this.element.setAttribute('aria-expanded', 'true');
                    this.setLabel(this.labelClose);

                    setTimeout(() => {
                        header.classList.add('nav-active');
                        if (isMobile) window.dispatchEvent(new CustomEvent('lock'));
                    }, 450)

                    if ($('#navigation').length) {
                        gsap.to("#navigation", {
                            height: 'auto',
                            duration: animDuration,
                            // duration: 5,
                            ease: easeVal
                        });
                    }

                    gsap.fromTo(".menu li", {opacity: 0, y: '-25px'}, {
                        opacity: 1,
                        y: '0',
                        stagger: 0.02,
                        duration: animDuration,
                        ease: easeVal,
                        delay: 0.15
                    });

                    gsap.fromTo(".nav-list li", {opacity: 0, y: '-30px'}, {
                        opacity: 1,
                        y: '0',
                        stagger: 0.03,
                        duration: animDuration,
                        ease: easeVal,
                        delay: 0.2
                    });

                    if (!isMobile && $("#header:not(.search_visible) .header-search").length) {
                        gsap.fromTo("#header:not(.search_visible) .header-search", {
                            opacity: 0,
                            y: '-20px',
                            visibility: 'hidden'
                        }, {
                            opacity: 1,
                            y: '0',
                            visibility: 'visible',
                            duration: animDuration,
                            ease: easeVal,
                            delay: 0.15
                        });
                    }

                    if (isMobile
                        && header.classList.contains('header--on-homepage')
                        && searchTrigger
                        && !searchTrigger.classList.contains('scroll-search-active')
                        && !searchTrigger.classList.contains('nav-search-active')) {
                        searchTrigger.classList.add('nav-search-active');
                        gsap.fromTo(".search-trigger", {opacity: 0, y: '-20px'}, {
                            opacity: 1,
                            y: '0',
                            duration: animDuration,
                            ease: easeVal,
                            delay: 0.2
                        });
                    }
                    this.isVisible = true;
                },
                close() {
                    // For navigation close
                    navigation.classList.add('navigation--is-hiding');
                    header.classList.remove('nav-active');
                    if (isMobile) window.dispatchEvent(new CustomEvent('unlock'));
                    this.element.classList.remove('menu-button--is-active');
                    this.element.setAttribute('aria-expanded', 'false');
                    this.setLabel(this.labelOpen);
                    header.classList.remove('active');

                    setTimeout(() => {
                        if(navigation.classList.contains('navigation--is-hiding')) {
                            navigation.classList.remove('navigation--is-hiding');
                            navigation.classList.add('navigation--is-hidden');
                        }
                    }, 500);

                    if (!isMobile && $('#header:not(.search_visible) .header-search').length) {
                        gsap.fromTo("#header:not(.search_visible) .header-search", {
                            opacity: 1,
                            y: '0',
                            visibility: 'visible'
                        }, {opacity: 0, y: '-20px', visibility: 'hidden', duration: animDuration, ease: easeVal});
                    }

                    if ($('#navigation').length) {
                        gsap.to("#navigation", {
                            height: '0',
                            duration: 2000,
                            ease: easeVal
                        });
                    }

                    if (isMobile && searchTrigger && searchTrigger.classList.contains('nav-search-active')) {
                        searchTrigger.classList.remove('nav-search-active');
                        gsap.fromTo(".search-trigger", {opacity: 1, y: '0'}, {
                            opacity: 0,
                            y: '-20px',
                            clearProps: true,
                            duration: animDuration,
                            ease: easeVal
                        });
                    }
                    this.isVisible = false;
                },
            }

            // the mobile visible search trigger opens a mobile search
            if (searchTrigger) {
                searchTrigger.addEventListener('click', (e) => {
                    e.preventDefault();
                    const fieldEl = $('.header-search .field');
                    if (fieldEl.is(':visible')) {
                        fieldEl.fadeOut(350);
                        searchTrigger.classList.remove('active');
                    } else {
                        fieldEl.fadeIn(350);
                        setTimeout(function () {
                            fieldEl.find('.input').focus();
                        }, 100);
                        searchTrigger.classList.add('active');
                    }
                });
            }

            // Navigation
            function NavHeaderHeight() {
                let navHeaderHeight = header ? header.getBoundingClientRect().height : 0;
                const navMainRow = document.querySelector('.nav-main-row');
                if (navMainRow) {
                    navMainRow.style.paddingTop = navHeaderHeight + 'px';
                }
            }

            function HeaderHeight() {
                let headerHeight = header ? header.getBoundingClientRect().height : 0;
                let pageBanner = document.querySelector('.page-banner');
                if (pageBanner) {
                    pageBanner.style.paddingTop = headerHeight + 'px';
                }
            }

            NavHeaderHeight();
            HeaderHeight();

            window.addEventListener('click', (e) => {
                if (e.target.isSameNode(menu.element)) {
                    e.preventDefault();
                    menu[menu.isVisible ? 'close' : 'open']();
                }

                // click outside
                if (e.target.isSameNode(menu.overlayElement) && menu.isVisible) {
                    menu.close();
                }

                return false
            });


            // Mobile search only for homepage
            window.addEventListener('scroll', (event) => {
                if (!searchTrigger) return;

                if (isMobile) {
                    if (window.pageYOffset > 10
                        && header.classList.contains('header--on-homepage')
                        && !searchTrigger.classList.contains('nav-search-active')
                        && !searchTrigger.classList.contains('scroll-search-active')) {
                        searchTrigger.classList.add('scroll-search-active')
                        gsap.fromTo(searchTrigger, {opacity: 0, y: '20px'}, {
                            opacity: 1,
                            y: '0',
                            duration: animDuration,
                            ease: easeVal
                        });
                    } else {
                        searchTrigger.classList.remove('scroll-search-active')
                        gsap.fromTo(searchTrigger, {opacity: 1, y: '0'}, {
                            opacity: 0,
                            y: '20px',
                            clearProps: true,
                            duration: animDuration,
                            ease: easeVal
                        });
                    }
                }
            }, {passive: true});

            // Hide search suggestions on window scroll globally
            window.addEventListener('scroll', (event) => {
                if(!document.activeElement.closest('input[name="search"]')) {
                    return;
                }

                if (document.activeElement instanceof HTMLElement && window.scrollY >= 150) {
                    document.activeElement.blur();
                }

                NavHeaderHeight();
            }, {passive: true});

            // Autocomplete
            window.addEventListener('keyup', (e) => {
                let target = e.target;

                if (target.classList.contains('input') && target.closest('.autocomplete')) {
                    let autocomplete = target.closest('.autocomplete');

                    autocomplete.classList[target.value === '' ? 'add' : 'remove']('not-empty');
                }
            });
        });
    }
}
